(function() {
    const passwordMaskToggle = document.querySelector('.js-passwordMaskToggle');
    const passwordElement = document.querySelector('.js-password');

    if (null !== passwordMaskToggle) {
        passwordMaskToggle.addEventListener('change', listener => {
            if (passwordMaskToggle.checked) {
                passwordElement.type = 'text';
            } else {
                passwordElement.type = 'password';
            }
        });
    }
})();